import {SHOW_TOAST, HIDE_TOAST} from './actionTypes';

export const successToast = message => ({
  type: SHOW_TOAST,
  toastType: 'success',
  message,
});

export const errorToast = message => ({
  type: SHOW_TOAST,
  toastType: 'error',
  message,
});

export const hideToast = () => ({
  type: HIDE_TOAST,
});
